import { alpha, type SxProps, type Theme } from '@mui/material/styles';

export type WarehouseCardVariant =
  | 'incidentPriority'
  | 'statusSummary'
  | 'operationalReadiness'
  | 'actionRequired'
  | 'proofReadiness'
  | 'workflowProgress'
  | 'info';

export function warehouseCardShellSx(variant: WarehouseCardVariant, theme: Theme): SxProps<Theme> {
  const base = {
    height: '100%',
    borderRadius: 1.75,
    p: 2,
  };

  switch (variant) {
    case 'incidentPriority':
      return {
        ...base,
        position: 'relative',
        overflow: 'hidden',
        borderColor: alpha(theme.palette.primary.main, 0.22),
        bgcolor: alpha(theme.palette.primary.main, 0.028),
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          width: 5,
          bgcolor: theme.palette.primary.main,
        },
      };
    case 'operationalReadiness':
      return {
        ...base,
        p: 2.75,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: alpha(theme.palette.info.main, 0.42),
        bgcolor: alpha(theme.palette.info.main, 0.08),
        boxShadow: `0 2px 12px ${alpha(theme.palette.info.main, 0.12)}`,
      };
    case 'workflowProgress':
      return {
        ...base,
        p: 1.75,
        borderColor: alpha(theme.palette.divider, 0.9),
        bgcolor: alpha(theme.palette.text.primary, 0.03),
        boxShadow: 'none',
      };
    case 'proofReadiness':
      return {
        ...base,
        position: 'relative',
        overflow: 'hidden',
        borderColor: alpha(theme.palette.success.main, 0.38),
        bgcolor: alpha(theme.palette.success.main, 0.06),
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          width: 5,
          bgcolor: theme.palette.success.main,
        },
      };
    case 'actionRequired':
      return {
        ...base,
        p: 1.5,
        borderColor: alpha(theme.palette.warning.main, 0.22),
        bgcolor: alpha(theme.palette.warning.main, 0.03),
      };
    case 'info':
      return {
        ...base,
        borderColor: alpha(theme.palette.divider, 0.65),
        bgcolor: alpha(theme.palette.background.paper, 0.4),
      };
    case 'statusSummary':
    default:
      return {
        ...base,
        borderColor: alpha(theme.palette.divider, 0.88),
        bgcolor: theme.palette.background.paper,
      };
  }
}
